import { Table } from "antd";
import { toDollar } from "../../utils/Constants/systemSetting";

export default function SimulationPercentileTable({
  data,
  truePercentileRuns,
  YEARS,
}) {
  // Time points as fractions of the full series length.
  // 10% = 1yr, 50% = 5yr, 100% = 10yr (max). Adjust labels + fractions together.
  // const TIME_POINTS = [
  //   { label: "1yr", fraction: 0.1 },
  //   { label: "5yr", fraction: 0.5 },
  //   { label: "10yr", fraction: 1.0 },
  // ];

  const TIME_POINTS = [
    { label: "1yr", fraction: 1 / YEARS },
    ...Array.from({ length: Math.floor(YEARS / 5) }, (_, i) => {
      const year = (i + 1) * 5;
      return { label: `${year}yr`, fraction: year / YEARS };
    }),
    ...(YEARS % 5 !== 0 && YEARS !== 1
      ? [{ label: `${YEARS}yr`, fraction: 1.0 }]
      : []),
  ];
  const PERCENTILES = [10, 25, 50, 75, 90];

  function getPercentileValue(sorted, p) {
    const idx = (p / 100) * (sorted.length - 1);
    const lo = Math.floor(idx);
    const hi = Math.ceil(idx);
    if (lo === hi) return sorted[lo];
    return sorted[lo] + (sorted[hi] - sorted[lo]) * (idx - lo);
  }

  function computeRows(percentileRuns) {
    if (
      typeof percentileRuns !== "object" ||
      !Object.values(percentileRuns).length
    ) {
      return [];
    }

    const percentileIterations = Object.values(percentileRuns);

    const seriesLength = percentileIterations[0].length;

    const getIndexForFraction = (fraction) =>
      Math.min(Math.round((seriesLength - 1) * fraction), seriesLength - 1);

    const avgRow = { key: "avg", percentile: "Average" };
    TIME_POINTS.forEach(({ label, fraction }) => {
      avgRow[label] = percentileRuns?.[`avg`]?.[getIndexForFraction(fraction)];
    });

    return [
      ...PERCENTILES.map((p) => {
        const row = { key: `p${p}`, percentile: `P${p}` };

        TIME_POINTS.forEach(({ label, fraction }) => {
          row[label] =
            percentileRuns?.[`p${p}`]?.[getIndexForFraction(fraction)];
        });
        return row;
      }),
      avgRow,
    ];
  }

  const BOLD_ROWS = ["p50", "avg"];

  const cellStyle = (record) =>
    BOLD_ROWS.includes(record.key) ? { fontWeight: "bold" } : {};
  const columns = [
    {
      title: "Percentile",
      dataIndex: "percentile",
      key: "percentile",
      align: "center",
      width: "20%",
      onCell: (record) => ({ style: cellStyle(record) }),
    },
    ...TIME_POINTS.map(({ label }) => ({
      title: label,
      dataIndex: label,
      key: label,
      align: "center",
      onCell: (record) => ({ style: cellStyle(record) }),

      render: (val, record) => toDollar(val, 2),
    })),
  ];

  const rows = computeRows(truePercentileRuns);

  return (
    <Table
      columns={columns}
      dataSource={rows}
      pagination={false}
      size="small"
      bordered
      onRow={(record) => ({
        style: BOLD_ROWS.includes(record.key) ? { fontWeight: "bold" } : {},
      })}
    />
  );
}
